enum TooltipPreference {
  LEFT = 'left',
  RIGHT = 'right',
  TOP_CENTER = 'top-center',
  TOP_LEFT = 'top-left',
  TOP_RIGHT = 'top-right',
  BOTTOM_CENTER = 'bottom-center',
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM_RIGHT = 'bottom-right',
  RIGHT_BOTTOM = 'right-bottom',
  RIGHT_CENTER = 'right-center',
  LEFT_BOTTOM = 'left-bottom',
  LEFT_CENTER = 'left-center',
}
export { TooltipPreference };
